import { render, staticRenderFns } from "./UserMyPurchasesDedicatedNumbers.vue?vue&type=template&id=e6fccdda&scoped=true&"
import script from "./UserMyPurchasesDedicatedNumbers.vue?vue&type=script&lang=js&"
export * from "./UserMyPurchasesDedicatedNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fccdda",
  null
  
)

export default component.exports